import React from "react";

export default () => (
  <section id="environment">
    <div className="section_left">
      <div className="section_hexagon" />
      <img className="image" src="images/environment/img.jpg" alt="true" />
    </div>
    <div className="section_right">
      <div className="section_title">
        <p>ENVIRONMENT</p>
        <h2>社内環境</h2>
      </div>
      <div className="section_contents">
        <p className="title">
          資格取得支援制度
        </p>
        <p className="text">
          システムエンジニアとしてのレベルアップのために、積極的な資格取得が望まれます。<br />SOLPACでは、資格試験合格後に受験費用を会社が負担し、資格の難易度に応じて一時金を支給します。<br />その数なんと124種類！
        </p>
      </div>
    </div>
  </section>
)


// WEBPACK FOOTER //
// ./src/Home/Environment.js